import { Injectable } from "@nestjs/common";
import { CreateQuestion } from "../entities/create-question";
import { CreateQuestionBankReqModel } from "@boi/shared-models";

@Injectable()
export class CreateQuestionAdapter {
    public convertDtoToEntity(dto: CreateQuestionBankReqModel, userId?: number): CreateQuestion {
        
        const question = new CreateQuestion();
        question.class = dto.classId;
        question.language = dto.language;
        question.subject = dto.subject;
        question.chapter = dto.chapter;
        question.topic = dto.topic || 0;
        question.qno = dto.qno;
        
        const qTypeId = Number(dto.questionTypeMaster || (dto as any).questiontype || dto.questionType || 0);
        const complexityId = Number(dto.complexity || dto.difficultyLevel || 0);
        
        question.complexity = complexityId;
        question.questiontype = qTypeId;
        
        question.marks = dto.marks || 0;
        question.question = dto.question;
        question.ability = dto.ability;
        question.abilityType = dto.abilityType;
        question.hasStimulus = dto.hasStimulus;
        question.estimatedTime = dto.estimatedTime;
        question.competencyCode = dto.competencyCode;
        question.preparedBy = dto.preparedBy;
        question.mobileNo = dto.mobileNo;
        question.hasAnswerKey = dto.hasAnswerKey || 'No';
        question.answerKey = dto.answerKey || null;
        
        if (userId) question.createdBy = userId;
        
        return question;
    }
}